// @greenlight-spec: 28-it-dashboard-ui.md#internal-health--internal-health-org-admin
// @greenlight-spec: 19-design-system.md

export const SERIES_COLORS = [
  'hsl(var(--viz-series-1))',
  'hsl(var(--viz-series-2))',
  'hsl(var(--viz-series-3))',
] as const;

/** Any line past the palette, or a replica no longer running: drawn, but without its own hue. */
export const OTHER_SERIES_COLOR = 'hsl(var(--slate) / 0.55)';

/**
 * A colour per name, by sorted name, so the dot beside a replica and its line
 * on the chart agree wherever either is drawn. Nothing for fewer than two:
 * one line needs no key.
 */
export function seriesColors(names: readonly string[]): ReadonlyMap<string, string> {
  const unique = [...new Set(names)].sort((a, b) => a.localeCompare(b));
  if (unique.length < 2) return new Map();
  return new Map(
    unique.flatMap((name, i) => (i < SERIES_COLORS.length ? [[name, SERIES_COLORS[i]!]] : [])),
  );
}

/** The cluster card's two resources, keyed by the dots beside its CPU and memory totals. */
export const CLUSTER_SERIES = { cpu: SERIES_COLORS[0], memory: SERIES_COLORS[1] } as const;
